import appConfig from '../../app.config.json';

type AppEnvironmentConfig = {
  appName?: string;
};

const configs = appConfig as Record<string, AppEnvironmentConfig>;
const currentConfig = configs[import.meta.env.MODE] ?? configs.production;

/** The product name for the current build environment. */
export const APP_NAME = currentConfig?.appName || '慧航AI-会话存档';
